const ValidateGlobalFormPatient = (_form, _listConfiguration) => {

    let statusValidation = false;
    let newValidations = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const rfcRegex = /^[A-ZÑ&]{4}\d{6}[A-Z0-9]{3}$/i;

    _listConfiguration.forEach(_field => {

        const fieldName = _field?.field;
        console.log("🚀 ~ ValidateGlobalFormPatient ~ fieldName:", fieldName)
        const value = _form[fieldName];
        console.log("🚀 ~ ValidateGlobalFormPatient ~ value:", value)
        const isRequired = _field?.required_field;


        if (fieldName === "email") {

            if (!value || value.trim() === "") {

                if (isRequired) {
                    newValidations[`${fieldName}_valid`] = true;
                    statusValidation = true;
                } else {
                    newValidations[`${fieldName}_valid`] = false;
                }

                return;
            }

            const emails = value.split(",");

            const invalidEmail = emails.some(email => !emailRegex.test(email.trim()));

            if (invalidEmail) {
                newValidations[`${fieldName}_valid`] = true;
                statusValidation = true;
            } else {
                newValidations[`${fieldName}_valid`] = false;
            }

            return;
        }



        if (fieldName === "birthday") {

            if (!value) {

                if (isRequired) {
                    newValidations[`${fieldName}_valid`] = true;
                    statusValidation = true;
                } else {
                    newValidations[`${fieldName}_valid`] = false;
                }

                return;
            }

            const today = new Date();
            const birthDate = new Date(value);

            if (isNaN(birthDate.getTime()) || birthDate > today) {
                newValidations[`${fieldName}_valid`] = true;
                statusValidation = true;
            } else {
                newValidations[`${fieldName}_valid`] = false;
            }

            return;
        }


        if (fieldName === "id_municipality") {

            const stateValue = _form["id_state"];

            const hasState =
                stateValue &&
                typeof stateValue === "object" &&
                stateValue.value;

            const hasMunicipality =
                value &&
                typeof value === "object" &&
                value.value;

            if (hasState && !hasMunicipality) {
                newValidations[`${fieldName}_valid`] = true;
                statusValidation = true;
            } else {
                newValidations[`${fieldName}_valid`] = false;
            }

            return;
        }


        if (fieldName === "rfc") {

            if (!value || value.trim() === "") {

                if (isRequired) {
                    newValidations[`${fieldName}_valid`] = true;
                    statusValidation = true;
                } else {
                    newValidations[`${fieldName}_valid`] = false;
                }

                return;
            }

            if (!rfcRegex.test(value.trim().toUpperCase())) {
                newValidations[`${fieldName}_valid`] = true;
                statusValidation = true;
            } else {
                newValidations[`${fieldName}_valid`] = false;
            }

            return;
        }


        if (
            value === null ||
            value === undefined ||
            value === "" ||
            value === 0 ||
            value === "0"
        ) {

            if (isRequired) {
                newValidations[`${fieldName}_valid`] = true;
                statusValidation = true;
            } else {
                newValidations[`${fieldName}_valid`] = false;
            }

        } else {
            newValidations[`${fieldName}_valid`] = false;
        }

    });

    return {
        statusValidation,
        newValidations
    };
};

export default ValidateGlobalFormPatient;
